import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import styles from "./Dashboard.module.scss";
import {
  getVisibilitySettings,
  updateVisibilitySettings,
  DEFAULT_VISIBILITY,
} from "../../utils/network/Crud";

const sections = [
  { key: "showEvents", label: "Events", desc: "Show upcoming events section & page" },
  { key: "showPosts", label: "Announcements", desc: "Show announcements feed on Home" },
  { key: "showGallery", label: "Gallery", desc: "Show gallery link & page" },
  { key: "showCommunity", label: "Community / Members", desc: "Show community members page" },
  { key: "showDonations", label: "Donations", desc: "Show Daanpeti (donations) section" },
  { key: "showExpenses", label: "Expenses", desc: "Show expenses section" },
  { key: "showLiveStream", label: "Live Stream Section", desc: "Master switch for the live stream block" },
];

const SiteSettings = () => {
  const [settings, setSettings] = useState(DEFAULT_VISIBILITY);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getVisibilitySettings().then((data) => {
      setSettings(data);
      setLoading(false);
    });
  }, []);

  const handleToggle = async (key) => {
    const updated = { ...settings, [key]: !settings[key] };
    setSettings(updated);
    setSaving(true);
    try {
      await updateVisibilitySettings(updated);
    } catch (error) {
      toast.error("Failed to save setting");
      setSettings(settings);
    }
    setSaving(false);
  };

  return (
    <div>
      <div className={styles.pageHeader}>
        <div>
          <h2>Site Settings</h2>
          <p>Control exactly what regular visitors can see on the public site.</p>
        </div>
      </div>

      <div className={styles.panel}>
        {loading ? (
          <div className={styles.emptyState}>Loading…</div>
        ) : (
          sections.map((section) => (
            <div className={styles.toggleRow} key={section.key}>
              <div>
                <strong>{section.label}</strong>
                <span>{section.desc}</span>
              </div>
              <label className={styles.switch}>
                <input
                  type="checkbox"
                  checked={!!settings[section.key]}
                  disabled={saving}
                  onChange={() => handleToggle(section.key)}
                />
                <span className={styles.slider}></span>
              </label>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default SiteSettings;
